import { authClient } from '#lib/authClient';

/**
 * Better Auth path: changePassword (needs the current password) and/or changeEmail
 * (sends a verification mail) are separate calls.
 * @param {string|null} trimmedEmail
 * @param {string|undefined} newPassword
 * @param {string|undefined} currentPassword
 * @returns {Promise<string|null>} The user ID on success
 */
const updateViaBetterAuth = async (trimmedEmail, newPassword, currentPassword) => {
	if (newPassword) {
		const { error } = await authClient.changePassword({ newPassword, currentPassword: currentPassword ?? '' });
		if (error) throw new Error(error.message ?? 'Passwortänderung fehlgeschlagen');
	}
	if (trimmedEmail) {
		const { error } = await authClient.changeEmail({
			newEmail: trimmedEmail,
			callbackURL: `${window.location.origin}/auth/confirm`,
		});
		if (error) throw new Error(error.message ?? 'E-Mail-Änderung fehlgeschlagen');
	}
	const { data } = await authClient.getSession();
	return data?.user?.id ?? null;
};

/**
 * Updates the user's email address and/or password via Better Auth.
 * Throws an error if no changes are provided or if the update fails.
 * @param {Object} [params={}]
 * @param {string} [params.newEmail] - New email address (optional, will be trimmed)
 * @param {string} [params.newPassword] - New password (optional)
 * @param {string} [params.currentPassword] - Current password (required by Better Auth to change the password)
 * @returns {Promise<string|null>} The user ID on success, or null
 */
export const updateUserPassword = async ({ newEmail, newPassword, currentPassword } = {}) => {
	const trimmedEmail = typeof newEmail === 'string' && newEmail.trim() ? newEmail.trim() : null;

	if (!trimmedEmail && !newPassword) {
		throw new Error('No user data to update provided');
	}

	return updateViaBetterAuth(trimmedEmail, newPassword, currentPassword);
};
